export var GENERIC_SAVE_ERROR = 'We couldn’t save your card. Please check your details and try again, or contact support if you need help.';
var PAYMENT_CALLBACK_ORIGIN = /^https:\/\/(?:[a-z0-9-]+-)?api-payments-svcs\.cloud\.tebra\.com$/i;
export function getTransactionErrorMessage(response) {
    var _a;
    var transactionResponse = response;
    return (((_a = transactionResponse === null || transactionResponse === void 0 ? void 0 : transactionResponse.error) === null || _a === void 0 ? void 0 : _a.message) || (transactionResponse === null || transactionResponse === void 0 ? void 0 : transactionResponse.responseMessage) || (transactionResponse === null || transactionResponse === void 0 ? void 0 : transactionResponse.errorMessage) || (transactionResponse === null || transactionResponse === void 0 ? void 0 : transactionResponse.message) ||
        GENERIC_SAVE_ERROR);
}
export function isCardSaveSuccessful(response) {
    var _a, _b;
    var status = (_a = response === null || response === void 0 ? void 0 : response.status) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var isCardSaved = String((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.isCardSaved).toLowerCase() === 'true';
    return status === 'PROCESSED' && isCardSaved;
}
export function getTransactionSetupId(transactionSetupUrl) {
    try {
        return new URL(transactionSetupUrl).searchParams.get('TransactionSetupID');
    }
    catch (_a) {
        return null;
    }
}
export function isExpectedTransactionMessage(event, expectedSource, expectedTransactionSetupId) {
    var _a, _b, _c;
    var response = (_a = event.data) === null || _a === void 0 ? void 0 : _a.response;
    var responseTransactionSetupId = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.transactionSetupId;
    var hasMatchingTransactionSetup = typeof responseTransactionSetupId === 'string' &&
        responseTransactionSetupId.toLowerCase() === (expectedTransactionSetupId === null || expectedTransactionSetupId === void 0 ? void 0 : expectedTransactionSetupId.toLowerCase());
    var isFailedCallbackWithoutTransactionSetup = ((_c = response === null || response === void 0 ? void 0 : response.status) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'FAILED' && !responseTransactionSetupId;
    return (PAYMENT_CALLBACK_ORIGIN.test(event.origin) &&
        expectedSource !== null &&
        expectedTransactionSetupId !== null &&
        event.source === expectedSource &&
        (hasMatchingTransactionSetup || isFailedCallbackWithoutTransactionSetup));
}
